import { apiFetch } from './apiClient';

/* `diasRestantes` vem calculado pelo backend de propósito -- se fosse
   contado aqui, o resultado mudaria conforme o fuso do computador de quem
   abre a tela, e é justamente isso que decide a cor do alerta. */
export const listarProcuracoes = (outorgado) =>
  apiFetch(`/procuracoes${outorgado ? `?outorgado=${outorgado}` : ''}`);

export const listarTiposProcuracao = () => apiFetch('/procuracoes/tipos');

export const criarProcuracao = (dados) =>
  apiFetch('/procuracoes', { method: 'POST', body: JSON.stringify(dados) });

export const atualizarProcuracao = (id, dados) =>
  apiFetch(`/procuracoes/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });

export const excluirProcuracao = (id) =>
  apiFetch(`/procuracoes/${id}`, { method: 'DELETE' });

/* Faixas de alerta pedidas: 15, 10 e 5 dias antes do vencimento.
   Da maior pra menor, porque a primeira que casar é a que vale. */
export const FAIXAS_ALERTA = [15, 10, 5];

/* verde > 15 dias | amarelo <= 15 | vermelho <= 5 ou já vencida.
   Procuração sem vencimento (prazo indeterminado) não tem cor nem alerta. */
export function faixaProcuracao(diasRestantes) {
  if (diasRestantes === null || diasRestantes === undefined) return 'semPrazo';
  if (diasRestantes < 0)  return 'vencida';
  if (diasRestantes <= 5) return 'critica';
  if (diasRestantes <= 15) return 'atencao';
  return 'ok';
}
